import {SimplePresentation, SimplePresentationRunnerController} from "../../SimplePresentationRunner";
import {gsap} from "gsap";
import {XW2GameMode, XwaysHoarder2} from "../../XwaysHoarder2";
import {BasicSymbol, SymbolStates} from "../../reels/symbols/BasicSymbol";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {XWaySymbol} from "../../reels/symbols/XWaySymbol";
import {XSplitSymbol} from "../../reels/symbols/XSplitSymbol";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";



export class LevelUpgradePresentation implements SimplePresentation {
    name: string = "LevelUpgradePresentation";
    private _stickyTl: gsap.core.Timeline;
    private _stickySyms: BasicSymbol[];
    private _conditionToContinue: boolean;
    private bingeRun:boolean = false;

    shouldRun(): boolean {
        return (XwaysHoarder2.model.data.mode === GameMode.FREESPIN || XwaysHoarder2.model.data.mode === XW2GameMode.SUPER_FREESPIN) && !XwaysHoarder2.model.isFreespinStarting && !XwaysHoarder2.model.isBaseGameRound && !XwaysHoarder2.model.isSuperFreespinStarting && !XwaysHoarder2.model.isRespinGameSpin && !XwaysHoarder2.model.gameData.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._stickyTl = gsap.timeline({
            onComplete: () => {
                this._conditionToContinue = false;
                XwaysHoarder2.plusFsView.resetAnimations();
                controller.setSkipCallback();
                controller.finish();
            }
        });
        XwaysHoarder2.trashSymView.isSkipped = false;

        this.bingeRun = false;



        this._conditionToContinue = !XwaysHoarder2.model.isSuperFreespinEnding && !XwaysHoarder2.model.isFreespinEnding;
        this._stickySyms = [];
        this.makeLockSymArray();
        //make total array for symbols to lock
        //do old one before

        let lockSoundPlayed:boolean = false;
        const newSyms: BasicSymbol[] = [];
        this._stickySyms.forEach((sym: BasicSymbol) => {
            if (sym.isOldSym && this._conditionToContinue) {
                this._stickyTl.add((<XWaySymbol | XSplitSymbol>sym).getStateAnimation(SymbolStates.STICKY), 0);
                if (!lockSoundPlayed) {
                    this._stickyTl.add(() => {
                        XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.TAPE_ON);
                    }, "<");
                    lockSoundPlayed = true;
                }
                XwaysHoarder2.reelView.reels[sym.reel.id].lockSpecialSymAndAddDummyBelow(sym.symID, "D", true);
            } else {
                newSyms.push(sym);
            }
        });
        this._stickySyms = newSyms;


        const currentLit: number [] = XwaysHoarder2.model.data.currentTopBarProgression;
        let currentCountTotal: number = 0;
        currentLit.forEach((val) => {
            currentCountTotal += val;
        });

        const nextLit: number [] = XwaysHoarder2.model.data.nextTopBarProgression;
        let nextCountTotal: number = 0;
        nextLit.forEach((val) => {
            nextCountTotal += val;
        });

        this._stickyTl.add(this.getIndicatorAnimation(currentCountTotal, nextCountTotal));


        controller.setSkipCallback(() => this.onStickySkip());

    }

    private makeLockSymArray(): void {
        for (let reelNo: number = 1; reelNo < 5; reelNo++) {
            [0, 1, 2].forEach((symNo: number) => {
                const currentSym: BasicSymbol = <BasicSymbol>XwaysHoarder2.reelView.reels[reelNo].model.getVisibleSymbolAt(symNo).positionable;
                if (currentSym.symbolName === "XW") {
                    if (currentSym.state !== SymbolStates.STICKY) {
                        this._stickySyms.push(currentSym);
                    }
                }
                if (currentSym.symbolName === "XS") {
                    if (currentSym.state !== SymbolStates.STICKY) {
                        this._stickySyms.push(currentSym);
                    }
                }
            });
        }
    }

    private getIndicatorAnimation(lastProgress: number, newProgress: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        if (newProgress > lastProgress) {
            const updateConf = XwaysHoarder2.fsIndicators.calculateUpdatePositions(lastProgress, newProgress);
            const diff: number = (XwaysHoarder2.model.data.freespinsLeft) - XwaysHoarder2.model.data.addedNumberOfFreeSpinInThisSpin + XwaysHoarder2.model.totalScatterLanded;
            let count: number = 1;

            [0, 1, 2, 3].forEach((boxIndex) => {
                switch (boxIndex) {
                    case 0:
                        if (updateConf.slot0.nrOfUpdates > 0) {
                            tl.add(this.getstickyAnim(updateConf.slot0.nrOfUpdates));
                            tl.add(XwaysHoarder2.fsIndicators.playSpineToLit(boxIndex, updateConf.slot0.fromId, updateConf.slot0.toId, updateConf), "<");
                            if (updateConf.slot0.toId === 3 && this._conditionToContinue) {
                                tl.add(XwaysHoarder2.fsReelAnimHandler.getTrashAnimation(0, XwaysHoarder2.model.reels));
                                tl.add(
                                    XwaysHoarder2.plusFsView.playIndicatorSpine(0, () => {
                                        SlotGame.keypadPlugin.setZeroBetSpinCounter(diff + count++);
                                    })
                                );
                                tl.add(() => {
                                }, "+=0.3");
                            }
                        }
                        break;
                    case 1:
                        if (updateConf.slot1.nrOfUpdates > 0) {
                            tl.add(this.getstickyAnim(updateConf.slot1.nrOfUpdates));
                            tl.add(XwaysHoarder2.fsIndicators.playSpineToLit(boxIndex, updateConf.slot1.fromId, updateConf.slot1.toId, updateConf), "<");
                            if (updateConf.slot1.toId === 3 && this._conditionToContinue) {
                                tl.add(XwaysHoarder2.fsReelAnimHandler.getTrashAnimation(1, XwaysHoarder2.model.reels));
                                tl.add(
                                    XwaysHoarder2.plusFsView.playIndicatorSpine(1, () => {
                                        SlotGame.keypadPlugin.setZeroBetSpinCounter(diff + count++);
                                    })
                                );
                                tl.add(() => {
                                }, "+=0.3");
                            }
                        }
                        break;
                    case 2:
                        if (updateConf.slot2.nrOfUpdates > 0) {
                            tl.add(this.getstickyAnim(updateConf.slot2.nrOfUpdates));
                            tl.add(XwaysHoarder2.fsIndicators.playSpineToLit(boxIndex, updateConf.slot2.fromId, updateConf.slot2.toId, updateConf), "<");
                            if (updateConf.slot2.toId === 3 && this._conditionToContinue) {
                                tl.add(XwaysHoarder2.fsReelAnimHandler.getTrashAnimation(2, XwaysHoarder2.model.reels));
                                tl.add(
                                    XwaysHoarder2.plusFsView.playIndicatorSpine(2, () => {
                                        SlotGame.keypadPlugin.setZeroBetSpinCounter(diff + count++);
                                    })
                                );
                                tl.add(() => {
                                }, "+=0.3");
                            }
                        }
                        break;
                    case 3:
                        if (updateConf.slot3.nrOfUpdates > 0 && this._conditionToContinue) {
                            tl.add(this.getstickyAnim(updateConf.slot3.nrOfUpdates));
                            tl.add(XwaysHoarder2.fsIndicators.playSpineToLit(boxIndex, updateConf.slot3.fromId, updateConf.slot3.toId, updateConf), "<");
                            if (updateConf.slot3.toId === 3) {
                                this.bingeRun = true;
                                XwaysHoarder2.reelView.symbolsToNormalLayer();

                                tl.add(
                                    XwaysHoarder2.plusFsView.playIndicatorSpine(3, () => {
                                        SlotGame.keypadPlugin.setZeroBetSpinCounter(XwaysHoarder2.model.data.freespinsLeft);
                                    })
                                );
                                tl.add(XwaysHoarder2.bonusDoors.closeGate(XW2GameMode.BINGE_SPINS));
                                tl.add(XwaysHoarder2.fsReelAnimHandler.getTrashAnimation(3, XwaysHoarder2.model.reels));
                                tl.add(() => {
                                    XwaysHoarder2.fsIndicators.hide();
                                }, "<");

                                tl.add(() => {
                                }, "+=0.3");
                            }
                        }
                        break;
                }
            });
        }

        return tl;
    }

    private getstickyAnim(num: number): gsap.core.Timeline {
        const animTL: gsap.core.Timeline = gsap.timeline();
        if (this._conditionToContinue) {
            let lockSoundPlayed: boolean = false;
            for (let i: number = 0; i < num; i++) {
                const symbol: BasicSymbol | undefined = this._stickySyms.shift();
                if (symbol) {
                    animTL.add((<XWaySymbol | XSplitSymbol>symbol).getStateAnimation(SymbolStates.STICKY), 0);
                    if (!lockSoundPlayed) {
                        animTL.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.TAPE_ON);
                        }, "<");
                        lockSoundPlayed = true;
                    }
                    XwaysHoarder2.reelView.reels[symbol.reel.id].lockSpecialSymAndAddDummyBelow(symbol.symID, "D", true);
                }
            }
        }

        return animTL;
    }

    private onStickySkip(): void {
        XwaysHoarder2.trashSymView.isSkipped = true;
        this._stickyTl.totalProgress(1);
        XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.FS_PLUS);

        [XwaysHoarder2Sound.SCREAM_M4, XwaysHoarder2Sound.SCREAM_M5, XwaysHoarder2Sound.SCREAM_M6].forEach((soundName) => {
            XwaysHoarder2Sound.stopSound(soundName);
        });

        XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.RADIATION_ANIMATION);

        if(this.bingeRun) {
            XwaysHoarder2Sound.fadeOutAndStopSound({
                name: XwaysHoarder2Sound.BINGE_INTRO,
                duration: 100,
                to: 0
            });
            XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.BINGE_INTRO);
            this.bingeRun = false;
        }

    }
}